import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-small-spinner',
  templateUrl: './small-spinner.component.html',
  styleUrls: ['./small-spinner.component.css']
})
export class SmallSpinnerComponent implements OnInit {

  @Input() show:boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
